import React from 'react';
import { useNewGetAptitudeQuizQuery } from './NewAptitudeQuizSlice';
import Loading from 'components/global/layout/Loading';
import NewAptitudeInstructions from './NewAptitudeInstructions';

const NewGetAptitudeQuestion = () => {
  // changed this: useNewGetAptitudeQuizQuery , according to new aptitude slice
  const { isLoading, isError, data } = useNewGetAptitudeQuizQuery();
  return (
    <div>
      {isLoading || isError ? (
        <Loading />
      ) : (
        <NewAptitudeInstructions data={data} />
      )}
    </div>
  );
};

export default NewGetAptitudeQuestion;
